import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, HostListener, OnInit } from '@angular/core';
import { EventSortingService } from 'src/app/services/event-sorting.service';
import { LoadingService } from 'src/app/services/loading.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.scss']
})
export class PositionComponent implements OnInit {
  /***
   * The Array of Evens sorted by priority
   */
  positions = [];
  /**
   * The Pio of the First Pos
   */
  start: number = 9999;
  /**
   * Is the Page loading
   */
  loading: boolean = true;
  /**
   * Change the pos via the Drag and Drop
   * @param event 
   */
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.positions, event.previousIndex, event.currentIndex);
  }
  /**
   * Move the Event one Pos to the Top
   * @param event 
   */
  moveOnePositionUP(event: any) {
    moveItemInArray(this.positions, event, event - 1);
  }
  /**
   * Move the Event one Pos to the end
   * @param event 
   */
  moveOnePositionDown(event: any) {
    moveItemInArray(this.positions, event, event + 1);
  }
  /**
   * Move the Event to the first Pos
   * @param event 
   */
  moveOnePositionTop(event: any) {
    moveItemInArray(this.positions, event, 0);
  }
  /**
   * Move the Event to the last Pos
   * @param event 
   */
  moveOnePositionLast(event: any) {
    moveItemInArray(this.positions, event, this.positions.length - 1);
  }
  /**
   * constructor
   * Get the Current Positions=> set via priority on an Event
   * @param eventSortingService 
   * @param overlayService 
   */
  constructor(
    private eventSortingService: EventSortingService,
    private overlayService: OverlayService,
  ) {
    this.loading = true;
    this.eventSortingService.getSortedEvents().subscribe({
      next: (res: Array<any>) => {
        this.positions = [...res.sort((a, b) => b.priority - a.priority)];
        this.loading = false;
      },
      error: error => {
        console.log(error);
        this.loading = false;
      }
    })
  }
  /**
   * ngOnInit
   */
  ngOnInit() {
  }
  /**
   * save the changes if the page is left without saving
   */
  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    this.saveChanges();
  }
  /**
   * Save the new Positions
   */
  saveChanges() {
    this.positions.forEach((element, index) => {
      element.priority = this.start - index;
    });
    this.eventSortingService.setSortedEvents(this.positions).subscribe({
      next: (res: Array<any>) => {
        this.positions = [...res.sort((a, b) => b.priority - a.priority)];
        this.overlayService.openSnackBar("Positionen gespeichert!")
      },
      error: err => {
        console.log(err)
      }
    })
  }
}
